import { useState,useEffect } from "react";
import editresultapi from '../../api/editresult';
import loginapi from '../../api/login';
import { useNavigate } from "react-router-dom";


const AddACourse = ({ accessToken,setAccessToken,setRefreshFailed,sessions,semesters,rollno,courseTypes,reloadDetails}) => {
  const navigate = useNavigate();
  const [selectedSession, setSelectedSession] = useState(null);
  const [selectedSemester, setSelectedSemester] = useState(null);
  const [selectedCourseType, setSelectedCourseType] = useState(null);
  const [courseDetails, setCourseDetails] = useState(null);
  const [courseCode,setCourseCode]=useState('');
  const [coursLoaded,setCourseLoaded]=useState(true);
  const [showCourseTitle,setShowCourseTitle]=useState(false);
  const [titleText, setTitleText] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [canSave, setCanSave] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [showErrorText,setShowErrorText]=useState(false);

  function  computeCanSave()
  {
    if(selectedSession!=-1 && selectedCourseType!=-1 && selectedSemester!=-1&&courseDetails!=null)
    {
        setCanSave(true);
    }
    else{
        setCanSave(false);
    }
  }
  // Handle dropdown change
  const handleSessionChange = (event) => {
    setSelectedSession(event.target.value);setShowErrorText(false);
  };
  const handleSemesterChange = (event) => {
    setSelectedSemester(event.target.value);setShowErrorText(false);
  };
  const handleCourseTypeChange = (event) => {
    setSelectedCourseType(event.target.value);setShowErrorText(false);
  };
  const loadCourseDetails = async (event) => {
    if(courseCode){
    setCourseLoaded(false);
    event.preventDefault();
     try{       
          //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
          const response=await editresultapi.post('/getCourseDetails',{rollno,courseCode},{headers:{'Authorization':`Bearer ${accessToken}`}});  
          setCourseDetails(response.data.courseDetails);
          }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);            
              const nat=x['data']['accessToken'];
              const lt=x['data']['loginType'];
              
              setAccessToken(nat);
              setRefreshFailed(false);  
                if(lt.toLowerCase()==="admin")
                  {
                        try{       
                          //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                          const response=await editresultapi.post('/getCourseDetails',{rollno,courseCode},{headers:{'Authorization':`Bearer ${nat}`}});                         
                          setCourseDetails(response.data.courseDetails);
                      }
                      catch(err)
                      {
                        if( err.response.status===403)
                          {
                            navigate(`/accessdenied`); 
                          }
                        alert('refresh failed unusual'+JSON.stringify(err));
                        setAccessToken('');
                        setRefreshFailed(true);  
                      }
                    }
              }
              catch(err)
              {
                alert("error: "+JSON.stringify(err));
                setAccessToken(''); 
                setRefreshFailed(true);              
              }
          }         
           finally
              {
                //setIsAppLoaded(true);
                //alert('app loaded'+accessToken);
                setCourseLoaded(true);              
                setShowCourseTitle(true);
              }}
  };
  const handleTxtCodeChange = (event) => {
    setCourseCode(event.target.value);setShowErrorText(false);
    setCourseDetails(null);
    setShowCourseTitle(false);
  };
  const onSaveHandler = async () => {
    setIsSaving(true);setShowErrorText(false);
    try{       
        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
        const response=await editresultapi.post('/AddNewFormFillupCourse',{rollno,selectedSession,selectedSemester,code:courseDetails.course_code,selectedCourseType},{headers:{'Authorization':`Bearer ${accessToken}`}});  
        //JSON.stringify(response.data);
          if(response.data.success)
            {
                await reloadDetails();setErrorText(response.data.message); setShowErrorText(true);
            }
            else{
               setErrorText(response.data.message); setShowErrorText(true);
            }
        }
        catch(err)
        {
          if( err.response.status===403)
            {
              navigate(`/accessdenied`); 
            }
          try{
            const config = { withCredentials: true };
            const x=await loginapi.get('/getAccessToken',config);            
            const nat=x['data']['accessToken'];
            const lt=x['data']['loginType'];
            
            setAccessToken(nat);
            setRefreshFailed(false);  
              if(lt.toLowerCase()==="admin")
                {
                      try{       
                        //const response=await api.get('/stats',{headers:{'Authorization':`Bearer ${accessToken}`}});
                        const response=await editresultapi.post('/AddNewFormFillupCourse',{rollno,selectedSession,selectedSemester,code:courseDetails.course_code,selectedCourseType},{headers:{'Authorization':`Bearer ${nat}`}});                         
                        if(response.data.success)
                            {
                                await reloadDetails();setErrorText(response.data.message); setShowErrorText(true);
                            }
                            else{
                               setErrorText(response.data.message); setShowErrorText(true);
                            }
                    }
                    catch(err)
                    {
                      if( err.response.status===403)
                        {
                          navigate(`/accessdenied`); 
                        }
                      alert('refresh failed unusual'+JSON.stringify(err));
                      setAccessToken('');
                      setRefreshFailed(true);  
                    }
                  }
            }
            catch(err)
            {
              alert("error: "+JSON.stringify(err));
              setAccessToken(''); 
              setRefreshFailed(true);              
            }
        }         
         finally
            {
              setIsSaving(false);  
            }
   
  };
  
  useEffect(() => {
    computeCanSave();
  },[selectedSession,selectedCourseType,selectedSemester,courseDetails]);

useEffect(() => {
    if (coursLoaded) {
        if(!showCourseTitle)
        {
            setTitleText("");
        }
        else if (showCourseTitle&&courseDetails && courseDetails.title) {
            setTitleText(courseDetails.title);
        } else if (showCourseTitle && (!courseDetails || !courseDetails.title)) {
            setTitleText("COURSE NOT FOUND");
        }        

    } else {
        setTitleText("please wait....");
    }
    
}, [coursLoaded, courseDetails, showCourseTitle]);

  return (
    <div className="w-full  flex flex-col py-2">
     <p className="w-full text-center">{`Adding courses for`} <span className="font-semibold">{rollno}</span></p>
      
      <label className="text-sm mb-1">Select Session:</label>
      <select
        className="py-1 border-b border-red-900 bg-transparent outline-none"
        value={selectedSession}
        onChange={handleSessionChange}
      >
        <option key={-1} value={'-1'}>
            {'PLEASE SELECT'}
          </option>
        {sessions.map((item, index) => (
          <option key={index} value={item.session}>
            {item.session}
          </option>
        ))}
      </select>

      <label className="text-sm mt-4 mb-1">Select Semester:</label>
      <select
        className="py-1 border-b border-red-900 bg-transparent outline-none"
        value={selectedSemester}
        onChange={handleSemesterChange}
      >
        <option key={-1} value={'-1'}>
            {'PLEASE SELECT'}
          </option>
        {semesters.map((item, index) => (
          <option key={index} value={item}>
            {item}
          </option>
        ))}
      </select>


      <label className="text-sm mt-4 mb-1">Course Code:</label>
      <input
        className="py-1 border-b border-red-900 bg-transparent outline-none"
        value={courseCode}
        onChange={handleTxtCodeChange}
        onBlur={loadCourseDetails}
      />
      <div
      className={`w-full  flex flex-col items-center mb-1 bg-yellow-100 transition-[max-height,opacity,transform] duration-500 ease-in-out overflow-hidden 
        ${ titleText.length>0 ? "max-h-[500px] opacity-100 scale-100" : "max-h-0 opacity-0 scale-100" }`}
      > 
        <p
            className={`w-full flex flex-col items-center  p-1
                ${courseDetails && courseDetails.title ? "text-green-500" : "text-red-500"}`}
            >
            {titleText || "\u00A0"}
            </p>
      </div>



      <label className="text-sm mt-4 mb-1">Select Type:</label>
      <select
        className="py-1 border-b border-red-900 bg-transparent outline-none"
        value={selectedCourseType}
        onChange={handleCourseTypeChange}
      >
        <option key={-1} value={'-1'}>
            {'PLEASE SELECT'}
          </option>
        {courseTypes.map((item, index) => (
          <option key={index} value={item}>
            {item}
          </option>
        ))}
      </select>

      <div className="w-full p-2 flex flex-col justify-end items-end mt-2 mb-8">
        <button
            onClick={onSaveHandler}
            className={`w-20 h-10 px-6 py-2 font-semibold rounded-lg shadow-md transition-all duration-300 text-xs
                ${canSave ? "bg-blue-600 text-white hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50" : "bg-gray-400 text-gray-200 cursor-not-allowed"}`}
            disabled={!canSave}
            >
            {isSaving ? (
                  <div className="w-5 h-5 border-[3px] border-gray-100 border-t-transparent rounded-full animate-spin"></div>

                ) : (
                    "SAVE"
                )}
        </button>
        {showErrorText&&<p>{errorText}</p>}

      </div>
    </div>
  );
};

export default AddACourse;
